
import SubmitForm from '../../graphql/mutations/SubmitForm'

export default {
  inheritAttrs: false,
  props: {
    subject: {
      type: String,
      default: null
    },
    meta: {
      type: Object,
      default: null
    },
    track: {
      type: Object,
      default: null
    },
    button: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'site.contactForm.send'
    },
    inputs: {
      type: Array,
      default: null
    },
    columns: {
      type: [Number, String, Object],
      default: 2
    }
  },
  computed: {
    mutation() {
      return SubmitForm
    },
    items() {
      if (this.inputs && this.inputs.length) {
        return this.inputs
      }

      return [
        {
          $type: 'input',
          $id: 'name',
          $prop: 'name',
          label: this.$t('site.contactForm.name'),
          $attrs: {
            span: 2,
          },
          rules: [{
            required: true,
            message: this.$t('site.validations.required'),
            trigger: 'change'
          }]
        },
        {
          $type: 'input',
          $id: 'email',
          $prop: 'email',
          label: this.$t('site.contactForm.email'),
          $attrs: {
            span: 2,
          },
          $el: {
            type: 'email'
          },
          rules: [{
            required: true,
            message: this.$t('site.validations.required'),
            trigger: 'change'
          },
          {
            type: 'email',
            message: this.$t('site.validations.email'),
            trigger: 'change'
          }]
        },
        {
          $type: 'input',
          $id: 'phone',
          $prop: 'phone',
          label: this.$t('site.contactForm.phone'),
          $attrs: {
            span: 2,
          },
          $el: {
            type: 'tel'
          }
        },
        {
          $type: 'input',
          $id: 'message',
          $prop: 'message',
          label: this.$t('site.contactForm.message'),
          $attrs: {
            span: 2
          },
          $el: {
            type: 'textarea',
            autosize: { minRows: 4, maxRows: 8 }
          },
          rules: [{
            required: true,
            message: this.$t('site.validations.required'),
            trigger: 'change'
          }]
        }
      ]
    }
  },
  methods: {
    onSuccess() {
      const track = this.track || {}
      const ename = track.eventName || 'contact_request'
      const edata = { category: 'contact', label: 'form' }

      this.$tracker.trackEvent(ename, { ...edata, ...track.eventData })
    },
    parseData(formData) {
      const value = { formData }

      if (this.subject) {
        value.subject = this.subject
      }

      if (this.meta) {
        value.metaData = this.meta
      }

      return value
    }
  }
}
